module.exports = __webpack_public_path__ + "images/sprites/ui/icons_comment_dots_orange_0aa2a803fa3a346bfb1d0547ad60aa23.png";